module.exports = __webpack_public_path__ + "222c9b45a79dbea3ed52c32e43047ef7.svg";